import type { MenuConfig, MenuItem } from '@/config/navigation';

export function filterMenuConfig(config: MenuConfig, hasTenantScope: boolean): MenuConfig {
  return {
    ...config,
    sideMenu: filterMenuItems(config.sideMenu, hasTenantScope),
    topMenu: filterMenuItems(config.topMenu, hasTenantScope),
    userMenu: filterMenuItems(config.userMenu, hasTenantScope)
  };
}

function filterMenuItems(items: MenuItem[] = [], hasTenantScope: boolean): MenuItem[] {
  return items
    .filter(item => hasTenantScope || !item.requiresTenant)
    .map(item => ({
      ...item,
      children: item.children ? filterMenuItems(item.children, hasTenantScope) : undefined
    }))
    .filter(item => (item.children ? item.children.length > 0 : true));
}
